<template>
    <div class="form-field form-sort" :rel="name" v-bind:class="{'has-suffix': suffix}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">

                <draggable v-model="internalValue" @start="drag=true" @end="drag=false" :options="{handle:'.drag'}">
                    <div v-for="(item, index) in internalValue" v-show="internalValue" class="drag">
                        <div>
                            {{ item.name }}
                        </div>
                        <div class="drag">
                            <i class="icon icon-drag"></i>
                        </div>
                    </div>
                </draggable>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormSort',
        props: ['value','label','name','placeholder','suffix','lang'],
        data: function () {
            return {
                internalValue: '',
                langClass:""
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Sort.vue